import { fillArr, randomNum } from '@hglobal/common';
import { FinancialRequestStatus } from '@pt/models';
import { environment } from '@pt/environment';

import { GetRequestDetailsEncryptedDataRes } from '../models';

export function getRequestDetailsEncryptedDataMock(id: string): GetRequestDetailsEncryptedDataRes {
  return {
    totalMessagesCount: 14,
    files: [
      `${environment.assetsHost}/assets/files/file.pdf`,
      `${environment.assetsHost}/assets/images/mock-article.png`,
    ],
    financialMessages: fillArr(randomNum(+id + 2, 2), i => ({
      requestIdHash: id,
      data: {
        date: new Date(),
        fromUser: id.toString(),
        message: 'Some comment here Some comment here Some comment here Some comment here',
        status: [
          FinancialRequestStatus.New,
          FinancialRequestStatus.InProgress,
          FinancialRequestStatus.Completed,
          FinancialRequestStatus.Rejected,
          FinancialRequestStatus.Canceled,
        ][randomNum(4)],
      },
    })),
  };
}
